<div class="report-container card">

  <!-- Main Stats Section -->
  <div class="report-section main-stats">
    <div class="stat-item">
      <span class="stat-label">TOTAL VISITS:</span>
      <span class="stat-value">{{ totalVisits }}</span>
    </div>
    <div class="stat-item">
      <span class="stat-label">SOLD:</span>
      <span class="stat-value">{{ soldCount }}</span>
    </div>
    <div class="stat-item nested-stats">
      <div>
        <span class="stat-label">NEW:</span>
        <span class="stat-value">{{ newCount }}</span>
      </div>
      <div>
        <span class="stat-label">USED:</span>
        <span class="stat-value">{{ usedCount }}</span>
      </div>
    </div>
    <div class="stat-item">
      <span class="stat-label">F STATUS:</span>
      <span class="stat-value">{{ fStatusCount }}</span>
    </div>
  </div>

  <hr>

  <!-- Performance Metrics Section -->
  <div class="report-section performance-stats">
    <div class="stat-item">
      <span class="stat-label">VSA:</span>
      <span class="stat-value">{{ vsa.count }} @ {{ vsa.percentage }}%</span>
    </div>
    <div class="stat-item">
      <span class="stat-label">PPM:</span>
      <span class="stat-value">{{ ppm.count }} @ {{ ppm.percentage }}%</span>
    </div>
    <div class="stat-item">
      <span class="stat-label">CCE:</span>
      <span class="stat-value">{{ cce.count }} @ {{ cce.percentage }}%</span>
    </div>
    <div class="stat-item">
      <span class="stat-label">PRU:</span>
      <!-- Using Angular's currency pipe for formatting -->
      <span class="stat-value">{{ pruValue | currency:'USD':'symbol':'1.0-0' }}</span>
      <!-- Adjust pipe parameters as needed: currencyCode, display, digitsInfo -->
    </div>
  </div>

  <hr>

  <!-- Follow Up Section -->
  <div class="report-section follow-up-stats">
    <h3 class="report-subtitle">{{ reportTitle }}</h3>
    <div class="stat-item">
      <span class="stat-label">{{ totalOutbound }} TOTAL OUTBOUND</span>
    </div>
    <div class="stat-item">
      <span class="stat-label">{{ salesAppts }} SALES APPTS</span>
    </div>
    <br> <!-- Simple spacing -->
    <div class="stat-item">
      <span class="stat-label">{{ tomorrowAppts }} TOMORROW APTS</span>
    </div>
    <div class="stat-item">
      <span class="stat-label">{{ wedAppts }} WED APTS</span> <!-- Assuming WED means Wednesday -->
    </div>
  </div>

  <hr>

  <!-- Trades Section -->
  <div class="report-section trades-stats">
    <div class="stat-item">
      <span class="stat-label">TRADES:</span>
      <span class="stat-value">{{ trades.count }} FOR {{ trades.outOf }}</span>
    </div>
  </div>

</div>
